import React from "react";
import { Table, Tbody, Td } from "./BiBleYear.style";

const TwoOneFourToTwoFourFour = () => {
  return (
    <Table class="table align-items-center table-flush">
      <Tbody>
        <tr>
          <Td>214</Td>
          <Td>โยบ 31,32</Td>
          <Td>สดุดี 86,87</Td>
          <Td>Job 31,32</Td>
          <Td>Psalms 86,87</Td>

          <Td>ทุกก้าวที่ฉันย่างไป</Td>
        </tr>
        <tr>
          <Td>215</Td>
          <Td>โยบ 33,34</Td>
          <Td>ลูกา 24</Td>
          <Td>Job 33,34</Td>
          <Td>Luke 24</Td>

          <Td>ความเข้าใจเป็นสิ่งสำคัญ</Td>
        </tr>
        <tr>
          <Td>216</Td>
          <Td>โยบ 35,36</Td>
          <Td>ฟิลิปปี 1</Td>
          <Td>Job 35,36</Td>
          <Td>Philippians 1</Td>

          <Td>สมควรได้รับการสรรเสริญ</Td>
        </tr>
        <tr>
          <Td>217</Td>
          <Td>โยบ 37,38</Td>
          <Td>สดุดี 88</Td>
          <Td>Job 37,38</Td>
          <Td>Psalms 88</Td>

          <Td>แค่ช่วงจังหวะเต้นของหัวใจ</Td>
        </tr>
        <tr>
          <Td>218</Td>
          <Td>โยบ 39,40</Td>
          <Td>ฟิลิปปี 2</Td>
          <Td>Job 39,40</Td>
          <Td>Philippians 2</Td>

          <Td>ความมหัศจรรย์เหลือหลาย</Td>
        </tr>
        <tr>
          <Td>219</Td>
          <Td>โยบ 41,42</Td>
          <Td>ฟิลิปปี 3</Td>
          <Td>Job 41,42</Td>
          <Td>Philippians 3</Td>

          <Td>เต็มและล้นไหล</Td>
        </tr>
        <tr>
          <Td>220</Td>
          <Td>สุภาษิต 1,2</Td>
          <Td>ฟิลิปปี 4</Td>
          <Td>Proverbs 1,2</Td>
          <Td>Philippians 4</Td>

          <Td>อยู่อย่างปรองดอง</Td>
        </tr>
        <tr>
          <Td>221</Td>
          <Td>สุภาษิต 3,4</Td>
          <Td>สดุดี 89</Td>
          <Td>Proverbs 3,4</Td>
          <Td>Psalms 89</Td>

          <Td>สุข เจริญ และสติปัญญา</Td>
        </tr>
        <tr>
          <Td>222</Td>
          <Td>สุภาษิต 5,6</Td>
          <Td>โคโลสี 1</Td>
          <Td>Proverbs 5,6</Td>
          <Td>Colossians 1</Td>

          <Td>เติบโตเป็นผู้ใหญ่</Td>
        </tr>
        <tr>
          <Td>223</Td>
          <Td>สุภาษิต 7,8</Td>
          <Td>โคโลสี 2</Td>
          <Td>Proverbs 7,8</Td>
          <Td>Colossians 2</Td>

          <Td>อย่าลืมเด็ดขาด</Td>
        </tr>
        <tr>
          <Td>224</Td>
          <Td>สุภาษิต 9,10</Td>
          <Td>สดุดี 90</Td>
          <Td>Proverbs 9,10</Td>
          <Td>Psalms 90</Td>

          <Td>ทำตัวตามสบาย</Td>
        </tr>
        <tr>
          <Td>225</Td>
          <Td>สุภาษิต 11,12</Td>
          <Td>โคโลสี 3</Td>
          <Td>Proverbs 11,12</Td>
          <Td>Colossians 3</Td>

          <Td>ความสวยงามที่แท้จริง</Td>
        </tr>
        <tr>
          <Td>226</Td>
          <Td>สุภาษิต 13,14</Td>
          <Td>โคโลสี 4</Td>
          <Td>Proverbs 13,14</Td>
          <Td>Colossians 4</Td>

          <Td>ตั้งเป้าให้สูง</Td>
        </tr>
        <tr>
          <Td>227</Td>
          <Td>สุภาษิต 15,16</Td>
          <Td>1 เธสะโลนิกา 1</Td>
          <Td>Proverbs 15,16</Td>
          <Td>1 Thessalonians 1</Td>

          <Td>แสงที่ส่องสว่าง</Td>
        </tr>
        <tr>
          <Td>228</Td>
          <Td>สุภาษิต 17,18</Td>
          <Td>สดุดี 91</Td>
          <Td>Proverbs 17,18</Td>
          <Td>Psalms 91</Td>

          <Td>หลักประกันที่ดี</Td>
        </tr>
        <tr>
          <Td>229</Td>
          <Td>สุภาษิต 19,20</Td>
          <Td>1 เธสะโลนิกา 2</Td>
          <Td>Proverbs 19,20</Td>
          <Td>1 Thessalonians 2</Td>

          <Td>ขอให้จริงใจ</Td>
        </tr>
        <tr>
          <Td>230</Td>
          <Td>สุภาษิต 21,22</Td>
          <Td>1 เธสะโลนิกา 3</Td>
          <Td>Proverbs 21,22</Td>
          <Td>1 Thessalonians 3</Td>

          <Td>เพื่อผลดีต่อตนเอง</Td>
        </tr>
        <tr>
          <Td>231</Td>
          <Td>สุภาษิต 23,24</Td>
          <Td>สดุดี 92,93</Td>
          <Td>Proverbs 23,24</Td>
          <Td>Psalms 92,93</Td>

          <Td>พูดตรงไปตรงมา</Td>
        </tr>
        <tr>
          <Td>232</Td>
          <Td>สุภาษิต 25,26</Td>
          <Td>1 เธสะโลนิกา 4</Td>
          <Td>Proverbs 25,26</Td>
          <Td>1 Thessalonians 4</Td>

          <Td>จง และ อย่า</Td>
        </tr>
        <tr>
          <Td>233</Td>
          <Td>สุภาษิต 27,28</Td>
          <Td>1 เธสะโลนิกา 5</Td>
          <Td>Proverbs 27,28</Td>
          <Td>1 Thessalonians 5</Td>

          <Td>วันนี้และวันหน้า</Td>
        </tr>
        <tr>
          <Td>234</Td>
          <Td>สุภาษิต 29,30</Td>
          <Td>2 เธสะโลนิกา 1</Td>
          <Td>Proverbs 29,30</Td>
          <Td>2 Thessalonians 1</Td>

          <Td>ตัดสินตัวเอง</Td>
        </tr>
        <tr>
          <Td>235</Td>
          <Td>สุภาษิต 31</Td>
          <Td>สดุดี 94</Td>
          <Td>Proverbs 31</Td>
          <Td>Psalms 94</Td>

          <Td>เมื่อไรคุณถึงจะเรียนรู้?</Td>
        </tr>
        <tr>
          <Td>236</Td>
          <Td>ปัญญาจารย์ 1-3</Td>
          <Td>2 เธสะโลนิกา 2</Td>
          <Td>Ecclesiastes 1-3</Td>
          <Td>2 Thessalonians 2</Td>

          <Td>อย่าถูกหลอก</Td>
        </tr>
        <tr>
          <Td>237</Td>
          <Td>ปัญญาจารย์ 4,5</Td>
          <Td>2 เธสะโลนิกา 3</Td>
          <Td>Ecclesiastes 4,5</Td>
          <Td>2 Thessalonians 3</Td>

          <Td>ไร้ผล-เกิดผล</Td>
        </tr>
        <tr>
          <Td>238</Td>
          <Td>ปัญญาจารย์ 6,7</Td>
          <Td>สดุดี 95,96</Td>
          <Td>Ecclesiastes 6,7</Td>
          <Td>Psalms 95,96</Td>

          <Td>คุณมองอย่างไร?</Td>
        </tr>
        <tr>
          <Td>239</Td>
          <Td>ปัญญาจารย์ 8,9</Td>
          <Td>1 ทิโมธี 1</Td>
          <Td>Ecclesiastes 8,9</Td>
          <Td>1 Timothy 1</Td>

          <Td>มีทางออกไหม?</Td>
        </tr>
        <tr>
          <Td>240</Td>
          <Td>ปัญญาจารย์ 10,11</Td>
          <Td>1 ทิโมธี 2</Td>
          <Td>Ecclesiastes 10,11</Td>
          <Td>1 Timothy 2</Td>

          <Td>สนใจรายละเอียด</Td>
        </tr>
        <tr>
          <Td>241</Td>
          <Td>ปัญญาจารย์ 12</Td>
          <Td>1 ทิโมธี 3</Td>
          <Td>Ecclesiastes 12</Td>
          <Td>1 Timothy 3</Td>

          <Td>คำแนะนำสำหรับทุกคน</Td>
        </tr>
        <tr>
          <Td>242</Td>
          <Td>เพลงซาโลมอน 1,2</Td>
          <Td>สดุดี 97,98</Td>
          <Td>Song of songs 1,2</Td>
          <Td>Psalms 97,98</Td>

          <Td>เพลงที่น่าร้อง</Td>
        </tr>
        <tr>
          <Td>243</Td>
          <Td>เพลงซาโลมอน 3,4</Td>
          <Td>1 ทิโมธี 4</Td>
          <Td>Song of songs 3,4</Td>
          <Td>1 Timothy 4</Td>

          <Td>หวังและฝัน</Td>
        </tr>
        <tr>
          <Td>244</Td>
          <Td>เพลงซาโลมอน 5,6</Td>
          <Td>1 ทิโมธี 5</Td>
          <Td>Song of songs 5,6</Td>
          <Td>1 Timothy 5</Td>

          <Td>ผู้คนที่น่ารัก</Td>
        </tr>
      </Tbody>
    </Table>
  );
};

export default TwoOneFourToTwoFourFour;
